import { crm, type OrderRow } from '@/lib/crm-client';
import { ConfirmDialog } from '@/components/ConfirmDialog';

interface Props {
  order: OrderRow;
  onCancel: () => void;
  /** Der Auftrag ist gelöscht — der Aufrufer lädt seine Liste neu. */
  onDeleted: () => void;
}

/**
 * Rückfrage vor dem Löschen eines Auftrags.
 *
 * Der Wortlaut stammt unverändert aus der früheren Auftragsseite: Positionen
 * und Aufgaben gehen mit, die Nummer wird nicht neu vergeben. Eine
 * zerstörerische Rückfrage wird nicht umformuliert, nur weil sie umzieht.
 */
export function OrderDeleteDialog({ order, onCancel, onDeleted }: Props) {
  return (
    <ConfirmDialog
      title={`Auftrag ${order.number} löschen?`}
      confirmLabel="Löschen"
      destructive
      onCancel={onCancel}
      onConfirm={async () => {
        await crm.orders.delete(order.id);
        onDeleted();
      }}
    >
      <p className="text-sm text-muted-foreground">
        Positionen und die {order.totalTasks} zugehörigen Aufgaben werden
        mitgelöscht. Die Nummer {order.number} wird nicht neu vergeben.
      </p>
    </ConfirmDialog>
  );
}
